export default "<mat-label *ngIf=\"label\">{{label}}</mat-label>\n<div>\n    <ng-content>\n\n    </ng-content>\n</div>\n";